import React, { useMemo } from 'react';
import { UIMessage } from 'ai';
import { Card, Icon } from '../../../components/ui';

interface ShipmentProgressCardProps {
  messages: UIMessage[];
  shipmentComplete: boolean;
}

function countToolResults(messages: UIMessage[], toolName: string): number {
  let count = 0;
  for (const msg of messages) {
    if (msg.role !== 'assistant' || !Array.isArray(msg.parts)) continue;
    for (const part of msg.parts) {
      if (part.type === 'tool-invocation') {
        const inv = (part as any).toolInvocation;
        if (inv?.toolName === toolName && inv?.state === 'result') count += 1;
      }
    }
  }
  return count;
}

const ShipmentProgressCard: React.FC<ShipmentProgressCardProps> = ({ messages, shipmentComplete }) => {
  const steps = useMemo(() => {
    const addressResults = countToolResults(messages, 'ValidateAddress');
    const ratesFetched = countToolResults(messages, 'GetShippingRates') >= 1;
    const draftCreated = countToolResults(messages, 'CreateDraftOrder') >= 1;

    return [
      { label: 'Origin validated', done: addressResults >= 1 },
      { label: 'Destination validated', done: addressResults >= 2 },
      { label: 'Rates fetched', done: ratesFetched },
      { label: 'Draft created', done: draftCreated },
      { label: 'Paid & label', done: shipmentComplete },
    ];
  }, [messages, shipmentComplete]);

  return (
    <Card className="ai-side-card">
      <div className="ov-card-head">
        <div>
          <div className="kicker">Progress</div>
          <div className="ov-card-title">Shipment checklist</div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '4px 14px 14px' }}>
        {steps.map((step) => (
          <div
            key={step.label}
            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0' }}
          >
            {step.done ? (
              <Icon name="checkCircle" size={16} style={{ color: 'var(--ok)', flexShrink: 0 }} />
            ) : (
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  border: '1.5px solid var(--line-strong)',
                  flexShrink: 0,
                  boxSizing: 'border-box',
                }}
              />
            )}
            <span
              style={{
                fontSize: 13,
                fontWeight: step.done ? 500 : 400,
                color: step.done ? 'var(--ink)' : 'var(--ink-3)',
              }}
            >
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ShipmentProgressCard;
